import React from 'react';
import T from 'prop-types';

import skeletons from './Skeletons';
import AppIcon from '../../../AppIcon';
import Button from '../../../Buttons/Button';
import QuickViewCloseButton from '../../QuickViewCloseButton';

import { handleCleanupRequests } from '../../actions';

const PreHeader = ({ companyData, settings, onClose }) => {
  const companyPageLink = `${window.location.origin}/companies/${companyData.ref_no}`;

  return (
    <div className="company-quick-view__preheader">
      <div className="company-quick-view__header-min-box">
        <div className="company-quick-view__header-min">
          <div className="company-quick-view__header-min-text">
            {settings.pending ? (
              skeletons.minHeader.metaContainer
            ) : (
              <div className="company-quick-view__header-min-text-head text-truncate">
                <AppIcon
                  url={companyData.icon_url}
                  size={16}
                  alt={companyData.name}
                  defaultBrokenNoStoreIcon="hicon-company-fill"
                  containerClasses="company-icon-container"
                />
                <span className="text-truncate">{companyData.name}</span>
              </div>
            )}
            <div className="company-quick-view__header-min-text-actions">
              {settings.pending ? (
                skeletons.minHeader.companyPageLink
              ) : (
                <Button size="sm" href={companyPageLink} onClick={handleCleanupRequests}>
                  View Company
                </Button>
              )}
              <QuickViewCloseButton size="sm" onClose={onClose} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PreHeader.propTypes = {
  companyData: T.object.isRequired,
  settings: T.shape({
    pending: T.bool,
    error: T.bool,
  }).isRequired,
  onClose: T.func.isRequired,
};

export default PreHeader;
